import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CurrentPermitDetails {
  [key: string]: any;
}

export interface CurrentPermitState {
  currentPermitDetails: CurrentPermitDetails;
}

const initialState: CurrentPermitState = {
  currentPermitDetails: {}
};

const currentPermitSlice = createSlice({
  name: 'currentPermit',
  initialState,
  reducers: {
    setCurrentPermitDetails(
      state,
      action: PayloadAction<CurrentPermitDetails>
    ) {
      state.currentPermitDetails = action.payload;
    },
    clearCurrentPermitData: (state) => {
      state.currentPermitDetails = {}; // Reset user details
    }
  }
});

export const { setCurrentPermitDetails, clearCurrentPermitData } =
  currentPermitSlice.actions;
export default currentPermitSlice.reducer;
